<template>
    <div>
        <Row :gutter="16">
            <Card>
                <p slot="title">{{t.routerName}}</p>
                <Row>
                    <Form :model="formItem" :label-width="120" label-position="right"
                          ref="form">
                        <Row>
                            <Col>
                                <FormItem :label="t.ad.adSpace" prop="spaceName">
                                    <Input v-model="formItem.spaceName" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.ad.name" prop="name">
                                    <Input v-model="formItem.name" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.ad.link" prop="link">
                                    <Input v-model="formItem.link" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.ad.pattern" prop="pattern">
                                    <Input v-model="formItem.pattern" readonly></Input>
                                </FormItem>
                                <Form-item :label="t.ad.startTime" prop="startTime">
                                    <Input v-model="formItem.startTime" readonly></Input>
                                </Form-item>
                                <Form-item :label="t.ad.endTime" v-if="showPatternTime">
                                    <Input v-model="formItem.endTime" readonly></Input>
                                </Form-item>
                                <FormItem :label="t.ad.patternHits" prop="patternHits"
                                          v-if="showPatternHits">
                                    <Input v-model="formItem.patternHits" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.ad.hits" prop="hits">
                                    <Input v-model="formItem.hits" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.ad.sortOrder" prop="sortOrder">
                                    <Input v-model="formItem.sortOrder" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.ad.status" prop="status">
                                    <Input v-model="formItem.status" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.ad.createBy" prop="createBy">
                                    <Input v-model="formItem.createBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.ad.createTime" prop="createTime">
                                    <Input v-model="formItem.createTime" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.ad.updateBy" prop="updateBy">
                                    <Input v-model="formItem.updateBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.ad.updateTime" prop="updateTime">
                                    <Input v-model="formItem.updateTime" readonly></Input>
                                </FormItem>

                                <FormItem :label="t.ad.description" prop="description">
                                    <tinymce id="id1" v-model="formItem.description" :toolbar1="toolbar1"
                                             :other_options="other_options" readonly></tinymce>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <span style="float: right;">
                                    <div class="ad-upload-list" v-if="formItem.image != null && formItem.image !== ''">
                                        <img :src="formItem.image"/>
                                        <div class="ad-upload-list-cover">
                                            <Icon type="ios-eye-outline" @click="openPreviewImageModal"></Icon>
                                        </div>
                                    </div>
                                    <div class="img-drag" v-else>
                                        <div style="width: 58px;height:58px;line-height: 58px;">
                                            <Icon type="ios-camera" size="20"></Icon>
                                        </div>
                                    </div>
                                </span>
                                <Modal v-model="previewImageModal" :width="previewImageModalWidth">
                                    <img :src="previewImage" style="max-width:100%;max-height:100%;">
                                    <div slot="footer">
                                        {{formItem.adSpaceName}}
                                    </div>
                                </Modal>
                            </Col>
                        </Row>
                    </Form>
                </Row>
            </Card>
        </Row>
    </div>
</template>
<script>
import { getAdInfo, getAdSpaceInfo } from '@/api/ad';

export default {
    name: 'content_ad_detail',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            previewImageModal: false,
            previewImage: null,
            previewImageWidth: 300,
            formItem: {
                name: '',
                link: '',
                pattern: '0',
                startTime: '',
                endTime: '',
                patternHits: 0,
                hits: 0,
                sortOrder: 0,
                status: '1',
                description: '',
                image: '',
                spaceName: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: '',
                adSpaceName: '',
            },
            showPatternTime: true,
            showPatternHits: false,
            loading: false,
            toolbar1: 'newnote print preview code',
            other_options: {
                height: 400,
                menubar: false,
                plugins: 'image code print preview',
            },
        };
    },
    beforeCreate() {
        import('tinymce-i18n/langs/ja');
    },
    computed: {
        previewImageModalWidth() {
            return this.previewImageWidth;
        },
    },
    methods: {
        patternSwitch() {
            //通过投放模式来初始化编辑初始界面
            if (this.formItem.pattern === '0') {
                //patternTime时间区间模式投放
                this.showPatternTime = true;
                this.showPatternHits = false;
            } else {
                //patternTime浏览量模式投放
                this.showPatternTime = false;
                this.showPatternHits = true;
                this.formItem.patternHits = parseInt(this.formItem.patternHits);
            }
        },
        //图片预览
        openPreviewImageModal() {
            this.previewImage = this.formItem.image;
            this.previewImageModal = true;
        },
    },
    async mounted() {
        //得到广告的信息
        const adInfo = await getAdInfo(this.$route.params.id);
        if (adInfo.ad != null) {
            this.formItem = adInfo.ad;
            this.patternSwitch();
            //状态判断
            if (adInfo.ad.status === '0') {
                this.formItem.status = this.t.ad.close;
            } else if (adInfo.ad.status === '1') {
                this.formItem.status = this.t.ad.open;
            }
            //广告投放模式判断
            if (adInfo.ad.pattern === '0') {
                this.formItem.pattern = this.t.ad.pDay;
            } else if (adInfo.ad.pattern === '1') {
                this.formItem.pattern = this.t.ad.pHits;
            }
            //得到广告位
            const adSpaceInfo = await getAdSpaceInfo(adInfo.ad.spaceId);
            if (adSpaceInfo.adSpace != null) {
                let width = parseInt(adSpaceInfo.adSpace.width);
                this.previewImageWidth = width < 100 ? 105 : width + 32;
                this.formItem.adSpaceName = adSpaceInfo.adSpace.name;
            }
        }
    },
};
</script>
<style lang="less" scoped>
.img-drag {
    background: #fff;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    text-align: center;
    /*cursor: pointer;*/
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;
    display: inline-block;
    width: 58px;
    height: 58px;
    margin-left: 10px;
    &:hover {
        border: 1px dashed #2d8cf0;
    }
    img {
        width: 100%;
        vertical-align: middle;
    }
}

.ad-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
}

.ad-upload-list img {
    width: 100%;
    height: 100%;
}

.ad-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}

.ad-upload-list:hover .ad-upload-list-cover {
    display: block;
}

.ad-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>
